/** The plan title as a menu: "{name} DRAFT ▾". The dropdown holds the
 *  level/activity counts and Discard draft — the slim top row stays clean. */
import React from "react";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import "./PlanTitleMenu.css";

interface Props {
  name: string;
  /** "N levels · M activities" — shown inside the menu, not on the row. */
  counts: string;
  onDiscard: () => void;
  disabled?: boolean;
}

const PlanTitleMenu: React.FC<Props> = ({ name, counts, onDiscard, disabled }) => {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef<HTMLDivElement | null>(null);
  useClickOutside(rootRef, () => setOpen(false), open);

  return (
    <div className="plan-title-menu" ref={rootRef}>
      <button
        type="button"
        className="plan-title-menu-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="plan-title-menu-name">{name}</span>
        <span className="plan-title-menu-draft">DRAFT</span>
        <span className="plan-title-menu-caret" aria-hidden="true">
          {open ? "▴" : "▾"}
        </span>
      </button>
      {open && (
        <div className="plan-title-menu-pop" role="menu">
          <div className="plan-title-menu-counts">{counts}</div>
          <div className="plan-title-menu-sep" aria-hidden="true" />
          <button
            type="button"
            className="plan-title-menu-discard"
            role="menuitem"
            disabled={disabled}
            onClick={() => {
              setOpen(false);
              onDiscard();
            }}
          >
            Discard draft
          </button>
        </div>
      )}
    </div>
  );
};

export default PlanTitleMenu;
